<template>
<div class="icon">
  <svg width="40px" height="40px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg"
       xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="currentColor" stroke-width="1.5" fill="none">
      <circle cx="15" cy="15" r="14.25"></circle>
      <g id="Group" transform="translate(9.000000, 9.000000)">
        <path d="M9.2,9.2 L12.4,12.4" stroke-linecap="round"></path>
        <circle cx="5" cy="5" r="5.75"></circle>
      </g>
    </g>
  </svg>

</div>
</template>

<script>
export default {
  name: "MobileMenuSearchIcon"
}
</script>

<style scoped>

</style>
